import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c12171f0&scoped=true"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"
import style0 from "./List.vue?vue&type=style&index=0&id=c12171f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12171f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c12171f0')) {
      api.createRecord('c12171f0', component.options)
    } else {
      api.reload('c12171f0', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=c12171f0&scoped=true", function () {
      api.rerender('c12171f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/List/List.vue"
export default component.exports